var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fade", appear: "" } }, [
    _vm.showAlert && _vm.whereIsRendered === _vm.alert.componentWhereIsRendered
      ? _c(
          "div",
          {
            class: [
              _vm.getType,
              "alert-container",
              {
                "render-at-the-bottom": _vm.renderAtTheBottom,
                "login-view": _vm.renderAtLoginView,
              },
            ],
          },
          [
            _c("div", { staticClass: "alert-text-container" }, [
              _c("span", {
                staticClass: "alert-subtext",
                domProps: { innerHTML: _vm._s(_vm.alert.subMessage) },
              }),
            ]),
            _c("div", {
              staticClass: "lf-icon-close close-icon",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.closeAlertAction.apply(null, arguments)
                },
              },
            }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }